export const BreadcrumbTitles = {
  welcome_screen: 'Welcome',
  quiz_screen: 'Hair Quiz',
  analyze_screen: '',
  result_screen: 'Analysis',
};
